import React, { Component } from 'react';
import _ from 'underscore';
import moment from 'moment';
import clone from 'clone';

import Accordion from './overview/Accordion';
import NameConversions from './overview/OverviewPropToLabelConversions';

function renderGroup (group, editsInState) {
    
    let rendered = [];
    let edits = clone(editsInState)

    Object.keys(group).map(function (el, index) {
        const { key, label } = group[el];
        let value = edits[key];
        if (value) {
            switch (key) {
                case 'description':
                    value = <div dangerouslySetInnerHTML={{__html: edits[key]}}/>;
                    break;

                case 'startDate':
                    value = moment(value, 'YYYY-MM-DD').format('MMM. D, YYYY');
                    break;

                case 'startTime':
                    value = moment(value, 'HH:mm:ss').format('hh:mm:ss a');
                    break;

                case 'stopDate':
                case 'stopTime':
                    if (edits.hasOwnProperty('autoStop') && edits.autoStop == true) {
                        if (key == 'stopDate') {
                            value = moment(value, 'YYYY-MM-DD').format('MMM. D, YYYY');
                        } else {
                            value = moment(value, 'HH:mm:ss').format('hh:mm:ss a');
                        }
                    } else {
                        edits[key] = false
                    }
                    break;

                case 'estRuntime':
                    if (value.length == 5) {
                        const minutes = moment.duration(value).asMinutes();
                        value = minutes === 1 ? minutes + " minute" : minutes + ' minutes';

                        if (minutes == 1440) {
                            value += ' (max)'
                        }
                        
                    } else {
                        value = 'invalid input'
                    }
                    break;

                case 'assignedEncoder':
                    value = value.simpleName;
                    break;

                case 'preroll':
                    value = value + ' minutes';

                case 'autoStop': 
                    value = 'On'

                case 'autoStart': 
                    value = 'On'

                case 'liveToBreak': 
                    value = 'On'

                default:
                    if (typeof value === 'boolean') {
                        value = value.toString().capitalizeWord();
                    }
            }

            if (edits[key]) {
                rendered.push(<li key={key + '-' + index}>
                    <strong>{label}:</strong> {value}
                </li>);
            }
        }
    }, this)

    return rendered || null;
}

class Overview extends Component {
    constructor (props) {
        super(props);

        const sorted = _.sortBy(NameConversions, 'order');
        const grouped = _.groupBy(sorted, 'group');

        this.state = {
            labels: grouped
        };
    }

    shouldComponentUpdate (nextProps) {
        return (
            this.props.edits !== nextProps.edits ||
            this.props.mode !== nextProps.mode
        );
    }

    render () {
        const { mode, edits } = this.props;
        const { labels } = this.state;

        return (<div>
            {mode !== null ? (<div>
                <h4>Mode: {mode == 'encoder' ? 'Live Event' : 'Event from Media'}</h4>
            </div>) : null}
            <Accordion title="General"
                values={renderGroup(labels.general, edits)}/>
            <Accordion title="Automation"
                values={renderGroup(labels.automation, edits)}/>
        </div>);
    }
}

Overview.propTypes = {};

export default Overview;
